import * as React from "react";
import { LineChart } from "@mui/x-charts/LineChart";

export default function CustomLineChart({
  dataset = [],
  xDataKey,
  yDataKey,
  xScaleType = "point",
  yScaleType = "linear",
  series = [],
  width = 250,
  height = 300,
  layout = "horizontal",
}) {
  const chartSeries = series.length > 0 ? series : [{ dataKey: yDataKey }];

  return (
    <LineChart
      dataset={dataset}
      xAxis={[{ dataKey: xDataKey, scaleType: xScaleType }]}
      series={chartSeries}
      yAxis={[{ scaleType: yScaleType }]}
      width={width}
      height={height}
      layout={layout}
      grid={{ vertical: true, horizontal: true }}
    />
  );
}
